import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function NotFound() {
  return (
    <>
    <Navbar />
    <div className="container d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
      <div className="text-center">
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h4 className="mb-4">Page Not Found</h4>
        <p className="text-muted mb-4">The page you are looking for does not exist or has been moved.</p>
        <Link to="/" className="btn btn-primary px-4">
          Back to Home
        </Link>
      </div>
    </div>
    </>
  );
}